import { SM } from '../assets/data/enum/storeModel.enum';
import { SAASBRANDNAME } from '../assets/data/enum/saasBrandName.enum';
import { productionBase } from './base/production.base';

export const environment = {
  ...productionBase,
  themeConfig: {
    ...productionBase.themeConfig,
    brand: 'landini',
    textName: 'Landini Farm',
    termsAndCondition: 'https://legal.xfarm.ag/#/terms-and-conditions?l=it&v=latest&b=landini',
    privacyPolicy: 'https://legal.xfarm.ag/#/privacy-policy?l=it&v=latest&b=landini',
    enableForgotPassword: false,
    enableRegistration: false,
    enableLoginForm: false,
    activeSocial: [SAASBRANDNAME.LANDINI],
    forceHideFunctionalityList: [
      SM.SM_ANALYTICS_SUSTAINABILITY,
      SM.SM_ANALYTICS_IMPACT,
      SM.SM_ANALYTICS_REGENERATIVE,
      SM.SM_ANALYTICS_OVERVIEW,
      SM.SM_ANALYTICS_CHAIN_MANAGEMENT,
      SM.SM_CONTRACT_MANAGEMENT,
      SM.SM_CONTRACT_AUDIT,
      SM.SM_GUIDE,
      SM.SM_EDUCATION_EDITOR,
      SM.SM_CROP_MAP,
      SM.SM_FARM_DOSSIER,
    ],
    showYaraNPK: false,
    alertPushSelectionEnable: false,
    newsSidebarTabActivation: false,
    advEnable: false,
    versionPublicPage: 'v1',
    welcomeUserCheck: false,
    store: false,
    storewebAppUrl: 'https://store-argo.xfarm.ag/landini/index.html',
  },
  apiBaseUrl: 'https://api-landini-farm.xfarm.ag/',
  SSOfrontAppCallback: 'https://app-landini-farm.xfarm.ag/#/oauthCheck?token=',
  launchDarklyKey: '67603fb8199e500973ebea58',
  assetsUrl: 'https://cdn.xfarm.ag/webapp/landini/',
  palette: {
    '--p-xfarm-50': '#dcecf9',
    '--p-xfarm-100': '#b8d9f3',
    '--p-xfarm-200': '#91c7ed',
    '--p-xfarm-300': '#63b5e6',
    '--p-xfarm-400': '#00a3e0',
    '--p-xfarm-500': '#1291c7',
    '--p-xfarm-600': '#1a80af',
    '--p-xfarm-700': '#1e6f97',
    '--p-xfarm-800': '#1f5f80',
    '--p-xfarm-900': '#1e4f6a',
    '--p-xfarm-950': '#1c3f54',
  },
  primary: '#00a3e0',
  primaryOpacity: '#5fbde2',
  primaryOpacity15: '#5fbde226',
  secondary: '#8f9a9b',
  btnSuccess: '#00a3e0',
  navBarColor: '#00a3e0',
  backgroundSplashScreen: '#00a3e0',
  textLoginVersion: '#FFFFFF',
  colorSidebarHeader: '#8f9a9b',
};
